import React from "react";
import { DemoHint } from "@/components/demo/DemoHint";
export function PostLoadCard({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "console";
}) {
  return (
    <div
      className={`rounded-xl border border-border bg-card ${className}`}
      style={{ boxShadow: "var(--shadow-card)" }}
    >
      {children}
    </div>
  );
}

export function PostLoadCardHeader({
  icon,
  title,
  children,
  variant = "default",
  demoHintKey,
}: {
  icon: React.ReactNode;
  title: string;
  children?: React.ReactNode;
  variant?: "default" | "atlas";
  demoHintKey?: string;
}) {
  const isAtlas = variant === "atlas";
  return (
    <div
      className="flex items-center justify-between px-4 py-3 border-b"
      style={isAtlas ? { backgroundColor: "#02ffd3", borderColor: "hsl(170 60% 45% / 0.3)" } : undefined}
    >
      <div className="flex items-center gap-2">
        {icon}
        <DemoHint hintKey={demoHintKey} side="bottom">
          <h4
            className="text-xs font-semibold uppercase tracking-wider"
            style={{ color: isAtlas ? "hsl(170 50% 15%)" : undefined }}
          >
            {title}
          </h4>
        </DemoHint>
      </div>
      {children}
    </div>
  );
}

export function FieldInput({
  label,
  required,
  icon,
  value,
  onChange,
  onFocus,
  onBlur,
  placeholder,
  error,
}: {
  label: string;
  required?: boolean;
  icon?: React.ReactNode;
  value?: string;
  onChange?: (v: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  placeholder?: string;
  error?: string;
}) {
  return (
    <div className="relative">
      {required && (
        <label className="text-[10px] font-medium text-muted-foreground mb-1 block">
          {label} <span className="text-destructive">*</span>
        </label>
      )}
      <input
        placeholder={placeholder || (required ? label : label)}
        className={`flex h-9 w-full rounded-md border bg-background px-3 py-2 text-xs text-foreground ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 pr-8 transition-shadow duration-150 ${error ? "border-destructive" : "border-input"}`}
        style={{
          "--tw-ring-color": "hsl(var(--brand-teal-deep))",
        } as React.CSSProperties}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {icon && <span className="absolute right-3 top-1/2 -translate-y-1/2">{icon}</span>}
      {error && <p className="text-[10px] text-destructive mt-0.5">{error}</p>}
    </div>
  );
}

export function ContactRow({ icon, text }: { icon: React.ReactNode; text: string }) {
  return (
    <div className="flex items-center gap-2 text-[11px] text-muted-foreground">
      <span className="text-muted-foreground/70">{icon}</span>
      {text}
    </div>
  );
}
